import Model from '@/models/Model.js';

export default class AnomalyDetection extends Model {
    static entity = 'anomaly_detections';

    static modelName = 'AnomalyDetection';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            parameters: this.attr(null),
            is_active: this.attr(null),

            ...super.fields(),
        };
    }
}
